import Header from './components/Header';
import Hero from './components/Hero';
import TodayHot from './components/TodayHot';
import Collections from './components/Collections';
import Community from './components/Community';
import Roundups from './components/Roundups';
import Briefs from './components/Briefs';
import TagsAndArchive from './components/TagsAndArchive';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TodayHot />
        <Collections />
        <Community />
        <Roundups />
        <Briefs />
        <TagsAndArchive />
      </main>
      <Footer />
    </div>
  );
}